import { useContext } from 'react'
import {
  AnalyticsContext,
  AnalyticsContextProps,
} from 'src/analytics/AnalyticsContext'

const useAnalyticsContext = (): AnalyticsContextProps =>
  useContext(AnalyticsContext)

export default useAnalyticsContext
